import requestManager from '../components/platformApi/requestManager'
import appHelper from "@util/appHelper";

export default {

    getConfig : function(code = '', callback) {
        requestManager.request({
            url: 'systemConfig/getConfig',
            params: {
                code : code
            }
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result);
        });
    }
};
